import React, { useState } from "react";
import Usuarios from "./usuarios";
import Templates from "./temas";
import Musicas from "./musicas";

import Categorias from "./categorias";
import Assinaturas from "./assinaturas";

function Admin() {
  const [aba, setAba] = useState("temas");

  return (
    <div>
      {/* MENU TOPO */}
      <div className="mb-3 d-flex gap-2 flex-wrap">

        <button
          className={`btn btn-primary ${aba === "templates" ? "" : "btn-outline-primary"}`}
          onClick={() => setAba("temas")}
        >
          Temas
        </button>

        

        <button
          className={`btn btn-primary ${aba === "musicas" ? "" : "btn-outline-primary"}`}
          onClick={() => setAba("musicas")}
        >
          Músicas
        </button>

        <button
          className={`btn btn-primary ${aba === "usuarios" ? "" : "btn-outline-primary"}`}
          onClick={() => setAba("usuarios")}
        >
          Usuários
        </button>

        <button
          className={`btn btn-primary ${aba === "categorias" ? "" : "btn-outline-primary"}`}
          onClick={() => setAba("categorias")}
        >
          Categorias
        </button>

         <button
          className={`btn btn-primary ${aba === "assinaturas" ? "" : "btn-outline-primary"}`}
          onClick={() => setAba("assinaturas")}
        >
          Assinaturas
        </button>

        

        
      </div>

      {/* CONTEÚDO */}
      <div>
        {aba === "usuarios" && <Usuarios />}
        {aba === "temas" && <Templates />}
        {aba === "musicas" && <Musicas />}
        {aba === "categorias" && <Categorias />}
        {aba === "assinaturas" && <Assinaturas />}




      </div>
    </div>
  );
}

export default Admin;
